
import Body from './body'
import BottomContext from './bottom'
const TempleteTwo = () => {
    return <>
        <Body></Body>
        <BottomContext></BottomContext>
    </>
}

export default TempleteTwo